module.exports = __webpack_public_path__ + "img/permi.fbec8d1.png";